import React from 'react'
import { Link } from 'react-router-dom'
import { scrollTop } from '../../Helpers/Helpers'
import { Helmet } from 'react-helmet'

const NotFound = props => {
    return (
        <div className="error-404 without-submenu">
            <Helmet>
                <link rel="canonical" href="https://viacamp.pl/404" />
                <title>404 - ViaCamp.pl</title>
                <meta name="prerender-status-code" content="404"></meta>
                <meta name="description" content="Strona nie została znaleziona. Sprawdź czy adres jest poprawny lub wróć na stronę główną ViaCamp.pl." />
                <meta name="robots" content="noindex" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="404 - Strona nie znaleziona - ViaCamp.pl" />
                <meta property="og:url" content="https://viacamp.pl/404" />
                <meta property="og:description" content="Strona nie została znaleziona. Sprawdź czy adres jest poprawny lub wróć na stronę główną ViaCamp.pl." />
            </Helmet>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-6 col-xl-5">
                        <div className="error-404__header">
                            <h2 className="error-404__title">404</h2>
                            <span className="error-404__paragraph d-block">No nie!</span>
                            <span className="error-404__span">Ktoś wyciągnął wtyczkę.</span>
                        </div>
                        <div className="error-404__buttons">
                            <Link onClick={scrollTop} to="/" className="btn btn-white btn-transparent">Strona główna</Link>
                            <Link onClick={scrollTop} to="/kontakt" className="btn btn-white btn-transparent">Kontakt</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound
